
import { defineComponent, onMounted } from "vue";
import BillList from "@/views/Pending/list/BillList.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "dashboard",
  components: {
    BillList,
  },
  data() {
    return {
      data: "",
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  },
});
